export const CHAINAGES_LIST = 'CHAINAGES_LIST';
export const CHAINAGES_LIST_SUCCESS = 'CHAINAGES_LIST_SUCCESS';
export const CHAINAGES_LIST_ERROR = 'CHAINAGES_LIST_ERROR';

export const CHAINAGE_DETAILS = 'CHAINAGE_DETAILS';
export const CHAINAGE_DETAILS_SUCCESS = 'CHAINAGE_DETAILS_SUCCESS';
export const CHAINAGE_DETAILS_ERROR = 'CHAINAGE_DETAILS_ERROR';

export const UPDATE_CHAINAGE = 'UPDATE_CHAINAGE';
export const UPDATE_CHAINAGE_SUCCESS = 'UPDATE_CHAINAGE_SUCCESS';
export const UPDATE_CHAINAGE_ERROR = 'UPDATE_CHAINAGE_ERROR';

export const AVAILABLE_CHAINAGES_LIST = 'AVAILABLE_CHAINAGES_LIST';
export const AVAILABLE_CHAINAGES_LIST_SUCCESS = 'AVAILABLE_CHAINAGES_LIST_SUCCESS';
export const AVAILABLE_CHAINAGES_LIST_ERROR = 'AVAILABLE_CHAINAGES_LIST_ERROR';

export const ASSET_REPORT_LIST = 'ASSET_REPORT_LIST';
export const ASSET_REPORT_LIST_SUCCESS = 'ASSET_REPORT_LIST_SUCCESS';
export const ASSET_REPORT_LIST_ERROR = 'ASSET_REPORT_LIST_ERROR';

export const ASSET_REPORT_UPDATE = 'ASSET_REPORT_UPDATE';
export const ASSET_REPORT_UPDATE_DETAILS = 'ASSET_REPORT_UPDATE_DETAILS';
export const ASSET_REPORT_UPDATE_SUCCESS = 'ASSET_REPORT_UPDATE_SUCCESS';
export const ASSET_REPORT_UPDATE_ERROR = 'ASSET_REPORT_UPDATE_ERROR';

export const ASSET_REPORT_DETAILS  = 'ASSET_REPORT_DETAILS';
export const ASSET_REPORT_DETAILS_ERROR  = 'ASSET_REPORT_DETAILS_ERROR';
export const ASSET_REPORT_DETAILS_SUCCESS = 'ASSET_REPORT_DETAILS_SUCCESS';

export const ASSET_REPORT_MAINTENANCE_LIST = 'ASSET_REPORT_MAINTENANCE_LIST';
export const ASSET_REPORT_MAINTENANCE_LIST_SUCCESS = 'ASSET_REPORT_MAINTENANCE_LIST_SUCCESS';
export const ASSET_REPORT_MAINTENANCE_LIST_ERROR = 'ASSET_REPORT_MAINTENANCE_LIST_ERROR';

export const ADD_ASSET_MAINTENANCE_DETAILS = 'ADD_ASSET_MAINTENANCE_DETAILS';
export const ADD_ASSET_MAINTENANCE_DETAILS_SUCCESS = 'ADD_ASSET_MAINTENANCE_DETAILS_SUCCESS';
export const ADD_ASSET_MAINTENANCE_DETAILS_ERROR = 'ADD_ASSET_MAINTENANCE_DETAILS_ERROR';

export const ADD_ASSET_REPORT = 'ADD_ASSET_REPORT';
export const ADD_ASSET_REPORT_SUCCESS = 'ADD_ASSET_REPORT_SUCCESS';
export const ADD_ASSET_REPORT_ERROR = 'ADD_ASSET_REPORT_ERROR';

export const MAINTENANCE_HISTORY_DETAILS  = 'MAINTENANCE_HISTORY_DETAILS';
export const MAINTENANCE_HISTORY_DETAILS_SUCCESS = 'MAINTENANCE_HISTORY_DETAILS_SUCCESS';
export const MAINTENANCE_HISTORY_DETAILS_ERROR = 'MAINTENANCE_HISTORY_DETAILS_ERROR';

export const MAINTENANCE_HISTORY_UPDATE = 'MAINTENANCE_HISTORY_UPDATE';
export const MAINTENANCE_HISTORY_UPDATE_SUCCESS = 'MAINTENANCE_HISTORY_UPDATE_SUCCESS';
export const MAINTENANCE_HISTORY_UPDATE_ERROR = 'MAINTENANCE_HISTORY_UPDATE_ERROR';
export const FILTER_CHAINAGE = 'FILTER_CHAINAGE';

export const DELETE_ASSETS = 'DELETE_ASSETS';
export const DELETE_ASSETS_SUCCESS = 'DELETE_ASSETS_SUCCESS';
export const DELETE_ASSETS_ERROR = 'DELETE_ASSETS_ERROR';

export const DELETE_ASSET_MAINTENANCE = 'DELETE_ASSET_MAINTENANCE';
export const DELETE_ASSET_MAINTENANCE_SUCCESS = 'DELETE_ASSET_MAINTENANCE_SUCCESS';
export const DELETE_ASSET_MAINTENANCE_ERROR = 'DELETE_ASSET_MAINTENANCE_ERROR';

export const ASSET_TYPE_LIST = 'ASSET_TYPE_LIST';
export const ASSET_TYPE_LIST_SUCCESS = 'ASSET_TYPE_LIST_SUCCESS';
export const ASSET_TYPE_LIST_ERROR = 'ASSET_TYPE_LIST_ERROR';